module.exports = __webpack_public_path__ + "img/circulo-info.a76d4fef.png";